// Espelho de UX das categorias de Tarefa da Agenda do Operacional (DEM-00034).
// ⚠️ FONTE DA VERDADE: server/operacional/agenda/operacional-agenda-regras.js
// (CATEGORIAS_TAREFA) — o backend valida no submit. Se divergir, quem manda é o
// backend; manter esta lista em sincronia. A Patricia pode ajustar a lista (aqui
// e lá) sem migration, porque não é ENUM no banco.
export const CATEGORIAS_TAREFA = [
  'Reunião',
  'Treinamento',
  'Pendência',
  'Avaliação 360',
  'Auditoria Financeira e de Estoque',
  'Avaliação SA',
  'Outro',
];

export const TIPO = { VISITA: 'Visita', TAREFA: 'Tarefa' };
